"use strict";

/**
 * @param {function(): Promise<*>} callback
 * @returns {function(): Promise<*>}
 */
const once = callback => {
    let result = null;

    return function() {
        if (!result) {
            result = callback();
        }
        return result;
    }
};

/**
 * @param {string} path
 * @returns {Promise<void>}
 */
const loadScript = path => new Promise(resolve => {
    const script = window.document.createElement('script');
    script.src = path;
    script.onload = () => resolve();
    window.document.body.appendChild(script);
});

export default {
    loadHls: once(() => loadScript('/resources/frontend/assets/js/hls.light.1.4.12.min.js')),
    loadVast: once(() => loadScript('/resources/frontend/assets/js/vast-client.5.0.0.min.js')),
    loadGoogleLogin: once(() => loadScript('https://accounts.google.com/gsi/client')),
    loadRecaptcha: once(() =>
        new Promise(resolve => {
            window.onRecaptchaLoad = () => {
                resolve(window.grecaptcha);
            };

            const script = window.document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js?render=explicit&onload=onRecaptchaLoad';
            window.document.body.appendChild(script);
        })
    ),
};



